const EventDetails = [
  {
    image: "/image/event-posters/kavi sammelan.png",
    title: "कवि सम्मेलन",
    name: "Kavi Sammelan",
    date: "",
    detailshort: "शेर ग़ज़ल शायरी से भरी काव्य प्रतियोगिता ",
    details: "शेर ग़ज़ल शायरी से भरी काव्य प्रतियोगिता ",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/chakravyuh.png",
    title: "चक्रव्यूह ",
    name: "Chakravyu",
    date: "",
    detailshort: "रामायण महाभारत एवं भारतीय पौराणिक कथाओं पर प्रश्नोत्तरी",
    details: "रामायण महाभारत एवं भारतीय पौराणिक कथाओं पर प्रश्नोत्तरी",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/bollywood masti bw.png",
    title: "बॉलीवुड मस्ती ",
    name: "Bollywood masti",
    date: "",
    detailshort: "हिन्दी फिल्म जगत से जुड़ी रोचक प्रतियोगिता ",
    details: "हिन्दी फिल्म जगत से जुड़ी रोचक प्रतियोगिता ",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/Adhikari (1).png",
    title: "अधिकारी",
    name: "Adhikari",
    date: "",
    detailshort: "प्रशासनिक सेवा परीक्षा के पैटर्न पर आधारित प्रतियोगिता",
    details: "प्रशासनिक सेवा परीक्षा के पैटर्न पर आधारित प्रतियोगिता",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/bharat final.png",
    title: "भारत को जानो",
    name: "Bharat ko Jano",
    date: "",
    detailshort: "भारतीय सामान्य ज्ञान पर आधारित प्रश्नोत्तरी",
    details: "भारतीय सामान्य ज्ञान पर आधारित प्रश्नोत्तरी",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/abhiyaan.png",
    title: "अभियान",
    name: "Abhiyaan",
    date: "",
    detailshort: "सामाजिक विषयों पर अपनी आवाज़ उठाने अवसर  ",
    details: "सामाजिक विषयों पर अपनी आवाज़ उठाने अवसर  ",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/Lafz.png",
    title: "लफ्ज़",
    name: "Lafz",
    date: "",
    detailshort: "ऑनलाइन आयोजित काव्य प्रतियोगिता ",
    details: "ऑनलाइन आयोजित काव्य प्रतियोगिता ",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/Kalam.png",
    title: "कलम",
    name: "Kalam",
    date: "",
    detailshort: "ऑनलाइन आयोजित लेखन प्रतियोगिता ",
    details: "ऑनलाइन आयोजित लेखन प्रतियोगिता ",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/abhivyakti temp.png",
    title: "अभिव्यक्ति",
    name: "Abhivyakti",
    date: "",
    detailshort: "Storytelling: अपने भीतर के कहानीकार को मंच देने का अवसर ",
    details: "Storytelling: अपने भीतर के कहानीकार को मंच देने का अवसर ",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/hasi ki mehfil.png",
    title: "हँसी की महफ़िल",
    name: "Hasi ki Mhefil",
    date: "",
    detailshort: "स्टैंड अप कॉमेडी ",
    details: "स्टैंड अप कॉमेडी ",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/patrakar.png",
    title: "पत्रकार बाबू",
    name: "Patrakar babu",
    date: "",
    detailshort: "अपने पत्रकारिता कौशल में वृद्धि करने सुनहरा अवसर",
    details: "अपने पत्रकारिता कौशल में वृद्धि करने सुनहरा अवसर",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
  {
    image: "/image/event-posters/aapki sansad.png",
    title: "आप की संसद",
    name: "Aap ki Sansad",
    date: "",
    detailshort: "संसदीय प्रणाली पर आधारित वाद -विवाद प्रतियोगिता",
    details: "संसदीय प्रणाली पर आधारित वाद -विवाद प्रतियोगिता",

    rules: `प्रतियोगिता के नवीनतम नियम आयोजन के समय साझा कर दिए जाएंगे `,
  },
];
export default EventDetails;
